import template from './surveys_setup_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class SurveySetupHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class SurveySetupHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new SurveySetupHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default
{
	name: 'SurveySetupHelp',
	dialog_class: SurveySetupHelpPage,
	template: template,
	template_filename: 'translation/dialogs/surveys_setup_help',
	provider: 'ps'
};
